import { NA_VALUE } from '@yme/common/constants';
import { checkBoatsProductType, checkScooterProductType } from '@yme/utils/productTypes';
import { STATUS_COLOR_CHANGE, STATUS_INIT, STATUS_RELOAD } from '../constants';
export function initialProductOptionFilter({ variantsOfProduct, }) {
    const activeVariant = variantsOfProduct.find((item) => {
        const res = [item.master, item.productOption].every((i) => i);
        return res;
    }) ||
        variantsOfProduct.find((item) => {
            const res = [item.productOption, item.prices.amount > 0, item.stock > 0].every((i) => i);
            return res;
        }) ||
        variantsOfProduct.find((item) => {
            const res = [item.productOption, item.prices.amount > 0].every((i) => i);
            return res;
        }) ||
        variantsOfProduct.find((item) => {
            const res = [item.productOption].every((i) => i);
            return res;
        });
    return activeVariant;
}
export function reloadProductOptionFilter({ sku, variantsOfProduct, }) {
    const activeVariant = variantsOfProduct.find((item) => [item.sku, item.sku === sku].every((i) => i)) ||
        variantsOfProduct.find((item) => [item.sku, item.productOption, item.stock > 0].every((i) => i));
    return activeVariant;
}
export function changeColorProductOptionFilter({ variantsOfProduct, productOption, }) {
    const activeVariant = variantsOfProduct.find((item) => {
        const res = [item.productOption === productOption, item.stock > 0].every((i) => i);
        return res;
    }) ||
        variantsOfProduct.find((item) => {
            const res = [item.productOption === productOption, item.prices.amount > 0].every((i) => i);
            return res;
        }) ||
        variantsOfProduct.find((item) => {
            const res = [item.productOption === productOption].every((i) => i);
            return res;
        });
    return activeVariant;
}
export function prepareProductOptionFilter({ colorVariants, index = 0, productOption = '', sku = '', statusType, }) {
    const currentProductType = colorVariants[index].productType
        .toUpperCase()
        .trim()
        .replace(' ', '')
        .replace('-', '');
    const commonProps = {
        colorItemIndex: index,
        colourId: colorVariants[index].colourId,
        productType: currentProductType,
    };
    const variantsOfProduct = colorVariants[index]?.variantsOfProduct;
    const isCurrentProduct = Boolean(variantsOfProduct &&
        (checkBoatsProductType(currentProductType) || checkScooterProductType(currentProductType)));
    if (isCurrentProduct) {
        let activeVariant;
        if (statusType === STATUS_INIT && !sku) {
            activeVariant = initialProductOptionFilter({
                variantsOfProduct,
            });
        }
        if (statusType === STATUS_RELOAD && sku) {
            activeVariant = reloadProductOptionFilter({
                variantsOfProduct,
                sku,
            });
        }
        if (statusType === STATUS_COLOR_CHANGE) {
            activeVariant = changeColorProductOptionFilter({
                variantsOfProduct,
                productOption,
            });
        }
        activeVariant =
            activeVariant ||
                variantsOfProduct.find((item) => item.stock > 0 && item.prices.amount > 0) ||
                variantsOfProduct.find((item) => item.prices.amount > 0) ||
                variantsOfProduct[0];
        return {
            ...commonProps,
            sku: activeVariant?.sku ?? '',
            productOption: activeVariant?.productOption ?? '',
        };
    }
    return {
        ...commonProps,
        sku: '',
        productOption: '',
    };
}
export function getAvailableSkuByProductOptionValue({ colorVariants, productOption, }) {
    const exactCase = colorVariants?.find((item) => item.productOption === productOption && item.stock > 0);
    const prettySuitableCase = colorVariants?.find((item) => item.productOption === productOption);
    return exactCase || prettySuitableCase;
}
export function buildRadioButtonsOptionsList(options) {
    const res = options.reduce((acc, itemValue) => {
        if (itemValue !== NA_VALUE) {
            const itemOptions = {
                value: itemValue,
            };
            return [...acc, itemOptions];
        }
        return acc;
    }, []);
    return res;
}
function extractNumber(str) {
    const match = str.match(/^\d+/);
    return match ? parseInt(match[0], 10) : 0;
}
export const SortFieldsWithNumbers = (array) => {
    return array.sort((a, b) => {
        const numA = extractNumber(a.value);
        const numB = extractNumber(b.value);
        return numA - numB;
    });
};
const findFirstNonGroupingProductVariant = (productVariantsByColor) => {
    for (const colorData of productVariantsByColor) {
        const foundVariant = colorData.variantsOfProduct.find((variant) => !variant.isGroupingProduct);
        if (foundVariant) {
            return foundVariant;
        }
    }
    return null;
};
export const sortByMasterVariations = (productVariantsByColor, allVariants) => {
    const masterVariationOptionName = findFirstNonGroupingProductVariant(productVariantsByColor)?.productOption;
    if (!masterVariationOptionName || allVariants[0]?.value === masterVariationOptionName) {
        return allVariants;
    }
    return allVariants.sort((a, b) => {
        if (a?.value === masterVariationOptionName) {
            return -1;
        }
        if (b?.value === masterVariationOptionName) {
            return 1;
        }
        return 0;
    });
};
